import { ChangeEvent } from 'react';

import { IKnmLegalBasis } from 'APIPackage/KnmModule/interfaces/IKnmLegalBasis';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import styles from './SelectLegalBasesItem.module.scss';
import { LegalBasisEditingAttributesNames } from '../types/LegalBasisEditingAttributesNames';

const LEGAL_BASIS_EDITING_ATTRIBUTES_NAMES: Array<
  keyof Omit<
    IKnmLegalBasis,
    'externalId' | 'atrNumber' | 'atrDate' | 'documentName' | 'instruction' | 'guid' | 'npaGuid'
  >
> = ['atrI', 'atrII', 'atrIII', 'atrIV', 'atrV'];

interface ISelectLegalBasesItemProps {
  element: IKnmLegalBasis;
  active: boolean;
  isDetailed?: boolean;
  onClick: () => void;
  onAttributeChange?: (parameterName: string, value: string) => void;
}

export const SelectLegalBasesItem = ({
  element,
  active,
  isDetailed,
  onClick,
  onAttributeChange,
}: ISelectLegalBasesItemProps) => {
  const elementAttributes = {
    ...(isDetailed && { 'data-expandable': true }),
    ...(active && { 'data-active': true }),
  };

  const handleAttributeInputChange = (attributeName: LegalBasisEditingAttributesNames) => (
    e: ChangeEvent<HTMLInputElement>,
  ) => {
    onAttributeChange && onAttributeChange(attributeName, e.target.value);
  };

  return (
    <div className={styles.Element} {...elementAttributes}>
      <button className={styles.Button} type="button" onClick={onClick}>
        {`${element.atrNumber ? `№:${element.atrNumber} ` : ''}${
          element.atrDate ? `от ${formatDate({ date: element.atrDate, dateFormat: DATE_FORMAT_LONG_FNS })} ` : ''
        }${element.documentName}`}
      </button>
      {isDetailed && (
        <>
          {LEGAL_BASIS_EDITING_ATTRIBUTES_NAMES.map(legalBasisAttributeName => (
            <TextInput
              key={legalBasisAttributeName}
              className={styles.ParameterInput}
              value={element[legalBasisAttributeName] || ''}
              onChange={handleAttributeInputChange(legalBasisAttributeName)}
            />
          ))}
        </>
      )}
    </div>
  );
};
